import type { ChatMessage } from '@multimod/shared';
import { PlatformIcon } from '@/components/ui/platform-icon';
import { PLATFORM_NAME } from './_shell';

interface Props {
  msg: ChatMessage;
}

function avatarColor(seed: string): { bg: string; fg: string } {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  const hue = h % 360;
  return { bg: `hsl(${hue} 30% 22%)`, fg: `hsl(${hue} 60% 75%)` };
}

export function SubjectCard({ msg }: Props) {
  const { displayName } = msg.author;
  const initial = displayName.slice(0, 1).toUpperCase() || '?';
  const { bg, fg } = avatarColor(displayName);
  const platformName = PLATFORM_NAME[msg.platform];

  return (
    <div
      role="group"
      aria-label="Mensagem sendo moderada"
      data-platform={msg.platform}
      className="subject-card flex items-center gap-3 p-3 rounded-md bg-bg-input border border-l-2 border-border"
    >
      <span
        data-avatar
        className="w-8 h-8 rounded-full grid place-items-center text-xs font-semibold shrink-0"
        style={{ background: bg, color: fg }}
        aria-hidden="true"
      >
        {initial}
      </span>
      <div className="flex flex-col min-w-0 flex-1">
        <span className="text-[13px] font-semibold truncate">{displayName}</span>
        <span className="text-xs text-fg-muted truncate">{msg.text}</span>
      </div>
      <span
        className={
          'inline-flex items-center gap-1 px-2 h-6 rounded text-[11px] font-medium shrink-0 ' +
          (msg.platform === 'twitch'
            ? 'bg-platform-twitch-soft text-platform-twitch'
            : 'bg-platform-youtube-soft text-platform-youtube')
        }
      >
        <PlatformIcon platform={msg.platform} size={12} />
        {platformName}
      </span>
    </div>
  );
}
